import React from 'react';
import { useTranslation } from 'react-i18next';

function formatValue(value, unit) {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'number' && Number.isFinite(value)) return `${value}${unit ? ` ${unit}` : ''}`;
  return String(value);
}

function DiffRow({ label, prevValue, nextValue, unit }) {
  const changed =
    prevValue !== null &&
    prevValue !== undefined &&
    nextValue !== null &&
    nextValue !== undefined &&
    String(prevValue) !== String(nextValue);

  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <div className="text-gray-600 font-semibold">{label}</div>
      <div className="flex items-center gap-2 font-mono text-gray-800">
        <span className={changed ? 'line-through text-gray-400' : ''}>{formatValue(prevValue, unit)}</span>
        <span className="text-gray-400">→</span>
        <span className={changed ? 'font-extrabold text-gray-900' : ''}>{formatValue(nextValue, unit)}</span>
      </div>
    </div>
  );
}

export default function WorkoutAdaptationCompareCard({ item }) {
  const { t } = useTranslation();
  const prev = item?.prev || null;
  const next = item?.suggested || null;
  if (!prev || !next) return null;

  const headerDate = next.date || prev.date || next.day || prev.day || '';
  const headerTitle = next.title || prev.title || item?.title || '';

  return (
    <div className="bg-white p-4 rounded border border-yellow-100 shadow-sm">
      <div className="flex justify-between items-start gap-3 mb-3 border-b border-gray-100 pb-2">
        <div className="min-w-0">
          <div className="text-xs text-gray-500 font-mono">{headerDate ? String(headerDate) : ''}</div>
          <div className="font-bold text-gray-900 truncate">{headerTitle}</div>
        </div>
        <div className="flex items-center gap-2 text-xs font-extrabold uppercase tracking-wide text-gray-500 whitespace-nowrap">
          <span className="bg-gray-100 px-2 py-1 rounded">{t('workout.planned')}</span>
          <span>→</span>
          <span className="bg-yellow-100 px-2 py-1 rounded text-yellow-800">{t('workout.suggested')}</span>
        </div>
      </div>

      <div className="space-y-2">
        <DiffRow label={t('workout.distance')} prevValue={prev.distance_km} nextValue={next.distance_km} unit="km" />
        <DiffRow label={t('workout.duration')} prevValue={prev.duration_min} nextValue={next.duration_min} unit="min" />
        <DiffRow label={t('workout.elevation')} prevValue={prev.altitude_gain_m} nextValue={next.altitude_gain_m} unit="m" />
      </div>

      {(prev.description || next.description) && (
        <div className="mt-3 grid md:grid-cols-2 gap-3">
          <div className="bg-gray-50 rounded p-3 border border-gray-100">
            <div className="text-xs font-extrabold uppercase tracking-wide text-gray-600">{t('workout.planned')}</div>
            <div className="text-sm text-gray-800 mt-1 whitespace-pre-line">{prev.description || '—'}</div>
          </div>
          <div className="bg-yellow-50 rounded p-3 border border-yellow-100">
            <div className="text-xs font-extrabold uppercase tracking-wide text-yellow-800">{t('workout.suggested')}</div>
            <div className="text-sm text-gray-900 mt-1 whitespace-pre-line">{next.description || '—'}</div>
          </div>
        </div>
      )}
    </div>
  );
}


